import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import financementStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'financement'
const customImplement: CustomStoreImplementationOptions = financementStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function financementFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('financement.title', 'Financement des formations | Matchers'),
        $description: $translate('financement.description', 'Nos formations ne sont pas gratuites pourtant, elles ne coûtent jamais rien aux entreprises. Matchers propose toujours des formations sur-mesure qualitatives et 100% finançables !'),
        $publishedTime: new Date('2023-04-05T14:36:49.474Z'),
        $modifiedTime: new Date('2023-06-13T08:04:43.155Z'),
        // Constants,
        $constants: { blocArgText: '<p><span style="color:#1100A2FF;">Pas de surprise, une formation Matchers est</span></p><p>&nbsp;<span style="color:#D93174FF;">une formation finançable à 100% !&nbsp;</span></p>' },
        // Data,
        $info: { financement: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      imageClick () {
        openUrl('https://www.matchers.fr/expert/194', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image1Click () {
        openUrl('https://www.matchers.fr/expert/195', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image2Click () {
        openUrl('https://www.matchers.fr/expert/482', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image3Click () {
        openUrl('https://www.matchers.fr/expert/342', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image4Click () {
        openUrl('https://www.matchers.fr/expert/398', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return financementFactory(storeId)()
}

export const financementRaw = financementFactory()
export const financement = () => financementRaw() as MergeCustomStore<typeof financementStoreCustom.instance>
